import CRUDService from "./geral/CRUDService";

export default class GrupoNGFTService extends CRUDService{
    constructor() {
        super("grupongft");
    }
}